import { useSelector } from 'react-redux';

import { RootState } from 'reducers/rootReducer';

export default function useLanguages() {
	return useSelector((state: RootState) => state.languages);
}
